// imports here
import axios from 'axios'

// const variables
const BASE_URL = 'http://localhost:8000/app/client/logo'


// initial state
const state = {
  items: [],
  errors: null,
  loading: false,
  meta: {}
}

// getters
const getters = {
  logo: state => state.items,
  meta: state => state.meta,
  hasErrors: state => state.errors,
  isLoading: state => state.loading
}

// mutations
const mutations = {
  setLogo: (state, payload) => {
    state.items = payload.data
    state.meta = payload.meta
  },
  deleteItem: (state, payload) => {
    const index = state.items.findIndex(item => item.id === payload.id)
    state.items.splice(index, 1)
  },
  setErrors: (state, payload) => state.errors = payload,
  setLoading: (state, payload) => state.loading = payload
}

// actions
const actions = {
  async getLogo (context, page) {
    context.commit('setErrors', null)
    context.commit('setLoading', true)
    try {
      const response = await axios.get(`${BASE_URL}?page=${page}`)
      context.commit('setLogo', response.data)
      context.commit('setLoading', false)
    } catch (error) {
      context.commit('setErrors', error.response.data)
      context.commit('setLoading', false)
    }
  },
  async uploadImage (context, payload) {
    context.commit('setErrors', null)
    try {
      const response = await axios.post(`${BASE_URL}/store`, payload)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error.response.data.errors)
    }
  },
  async deleteImage (context, payload) {
    context.commit('setErrors', null)
    try {
      const response = await axios.delete(`${BASE_URL}/${payload.id}`)
      context.commit('deleteItem', payload)
      return Promise.resolve(response.status)
    } catch (error) {
      context.commit('setErrors', error.response.data)
    }
  },
  setErrors: ({ commit }, payload) => commit('setErrors', payload),
  setLoading: ({ commit }, payload) => commit('setLoading', payload)
}

// export variables with namespaced
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
